import { AppLinkTree, PageLink } from "@megarax/links";

import { HttpUri } from "@megaron/http-uri";
import { getMegaraxPath, MegaraxUri } from "@megaron/megarax-uri";

import { mobileNavCollapsedBarHeightPx } from "./navConstants";

export const getMobileDrawerSheetHeight = (collapsedBarHeightPx = mobileNavCollapsedBarHeightPx): number =>
  Math.max(0, (window.visualViewport?.height ?? window.innerHeight) - collapsedBarHeightPx);

export const linkHref = (uri: MegaraxUri | HttpUri): string => getMegaraxPath.try(uri) ?? uri;

export const isLinkExternal = (uri: MegaraxUri | HttpUri): boolean => !MegaraxUri.isUri(uri);

export const isPageLinkActive = (
  pageLink: PageLink,
  pathname: string,
  searchParams: URLSearchParams,
): boolean => {
  if (pageLink.isActive) return pageLink.isActive(pathname, searchParams);
  if (isLinkExternal(pageLink.uri)) return false;

  const href = linkHref(pageLink.uri);
  return pathname === href || pathname.startsWith(`${href}/`);
};

export const isAppTreeActive = (
  appTree: AppLinkTree,
  pathname: string,
  searchParams: URLSearchParams,
): boolean => appTree.pageLinks.some((pageLink) => isPageLinkActive(pageLink, pathname, searchParams));

export const getAppHomeHref = (appTree: AppLinkTree): string => linkHref(appTree.uri);

export const isAppHomeExternal = (appTree: AppLinkTree): boolean => isLinkExternal(appTree.uri);
